import { SituationService } from './../service/situation.service';
import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { SocialUser } from '@abacritt/angularx-social-login';
import { map, Observable, of, tap, concatMap } from 'rxjs';
import { AuthService } from '../service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  // authState: Observable<boolean | UrlTree>;

  ignore = true; // 是否要忽略檢查退學身份 *開發時設true;

  constructor(private auth: AuthService, private router: Router, private sir: SituationService) {

    // return this.auth.authState$.pipe(
    //   tap(a => console.log(a)),
    //   map(a => a != null),
    //   map(a => {
    //     if (a === true) {
    //       return true;
    //     } else {
    //       return this.router.createUrlTree(['/', 'login']);
    //     }
    //   }),
    //   // tap(a => console.log(a))
    // );

  }


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.auth.authState$.pipe(
      // tap(a => console.log('canActivate', a)),
      map(a => a != null),
      concatMap(a =>
        (a == true)
          ? this.sir.getCLO013().pipe(
            // tap(a => console.log(a)),
            map(s => {
              if (s.length > 0) {  //有學生資料
                if (environment.dev) {
                  return true;
                }
                else if (['未入學', '保留入學', '退學'].includes(s[0].studY_STATUS_NAME) == false) {
                  return true;
                }
              }
              return false;
            })
          )
          : of(false)
      ),
      map(a => {
        if (a === true) {
          //登入中
          if (state.url == '/login')
            return this.router.createUrlTree(['/']);  //去預設頁
          else
            return true;  //直接去該頁
        } else {
          //未登入

          if (state.url == '/login' || state.url == '/logindev' || state.url.toLowerCase().startsWith('/simulatelogin'))
            return true;
          alert('此帳號非學生帳號，請確認後重新輸入，謝謝')
          return this.router.createUrlTree(['/', 'login']);
        }
      }),
    );



  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    console.log('canActivateChild');
    return true;
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    console.log('canLoad');
    return true;
  }
}
